import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutingConfig, SbRoutingButton } from '@models';

@Component({
    selector: 'app-sb-widget-button-bar',
    templateUrl: './sb-widget-button-bar.component.html',
    styleUrls: ['./sb-widget-button-bar.component.scss']
})
export class SbWidgetButtonBarComponent implements OnInit {
    @Input() buttons: SbRoutingButton[];
    /**
     * Context Data (object used to look for value used in RoutingConfig.idField or RoutingConfig.QueryParameters)
     */
    @Input() data: any;

    constructor(private router: Router) {}

    ngOnInit(): void {}

    buttonClicked(button: SbRoutingButton) {
        const routingConfig = button.routingConfig;
        if (routingConfig && routingConfig.targetUrl) {
            if (routingConfig.queryParameters) {
                this.routeUsingQueryParams(routingConfig);
            } else if (routingConfig.idField) {
                this.routeUsingIdField(routingConfig);
            } else {
                // Standard route with no parameters.
                this.router.navigate([routingConfig.targetUrl]);
            }
        }
    }

    private routeUsingIdField(routingConfig: RoutingConfig) {
        const targetUrl = '/' + routingConfig.targetUrl;
        const id = this.data[routingConfig.idField];
        if (id) {
            this.router.navigate(id ? [targetUrl, id] : [targetUrl]);
        } else {
            console.warn(
                'Could not find id in' +
                    JSON.stringify(this.data) +
                    ' from field: ' +
                    routingConfig.idField
            );
        }
    }

    private routeUsingQueryParams(routingConfig: RoutingConfig) {
        const params = {};
        routingConfig.queryParameters.forEach((qp) => {
            params[qp.queryParamName] = this.data[qp.sourcePath] || qp.defaultValue;
        });
        this.router.navigate([routingConfig.targetUrl], { queryParams: params });
    }
}
